// extracted by mini-css-extract-plugin
export var container = "_pn-0";
export var dotAnimation = "_pn-2";
export var dotsLoading = "_pn-1";